export { default as ElasticSearchSolidIcon } from './ElasticSearchSolidIcon';
